import { getInstancesDomainUtil } from 'modules/redux/selectors/domain/utils'
import { getUnreadPathsNotificationsUtil } from 'modules/notifications/utils'
import { bulkUpdateLegacyReduxAction } from 'modules/redux/actions/legacy/bulk-update'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save/index.js'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'

/**
 * Marks all the notifications as read.
 * @returns {Function}
 */
function readAllActionNotificationsAction () {
  return (dispatch, getState) => {
    // Get the notifications
    const notificationDomain = getState().notifications
    const notifications = getInstancesDomainUtil(notificationDomain)
    const paths = getUnreadPathsNotificationsUtil(notifications)
    // If the notifications are already read, noop
    if (!paths.length) {
      return
    }
    // Mark read as true
    const updates = paths.map(() => ({ read: true }))
    dispatch(
      bulkUpdateLegacyReduxAction({
        paths,
        updates
      })
    )

    paths.forEach((path, index) => {
      const notification = notifications[index]
      dispatch(
        saveLegacyReduxAction({
          path,
          endpoint: `/notifications/${getIdReduxUtil(notification)}`
        })
      )
    })
    // Save the changes
    // dispatch(
    //   bulkSaveLegacyReduxAction({ paths })
    // )
  }
}

export {
  readAllActionNotificationsAction
}
